import React from "react"
import { Div, Text } from "atomize"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCopy } from "@fortawesome/free-solid-svg-icons"
import { toast } from "react-toastify"
import { DateTime } from "luxon"
import { theme } from "../settings/config"
import { ROLE_LABELS } from "../utils/school.utils"
import { appURL } from "../utils/calendar.utils"

// Il codice da consegnare. Non si può rileggere dopo: sta in una collection
// che nessun client apre, ed è giusto così — un codice d'ingresso che
// chiunque possa sfogliare non è un codice. Per questo qui c'è un pulsante
// che lo copia già dentro un messaggio: è l'unico momento in cui si vede.
function InviteCredentials({ invite, schoolName }) {
	const expires = DateTime.fromISO(invite.expiresAt).setLocale("it")
	// i codici di prima dicevano solo se si gestiva
	const role = invite.role ?? (invite.canManageSchool ? "manager" : "colleague")

	const message =
		`Ti aggiungo su inCampo, dove segno le lezioni.\n\n` +
		`Vai su ${appURL()}, registrati e scegli "Ho il codice di un circolo".\n` +
		`codice: ${invite.code}\n\n` +
		`Ti sei già registrato? Vai in Profilo > Sezione circolo > "Entra in un altro circolo".\n\n` +
		`Vale fino al ${expires.toFormat("d LLLL")}.`

	const copy = async () => {
		try {
			await navigator.clipboard.writeText(message)
			toast.success("Copiato", { position: "top-center" })
		} catch {
			toast.error("Copialo a mano: il browser non me lo lascia fare", {
				position: "top-center",
			})
		}
	}

	return (
		<>
			<Div bg={theme.colors.surface} p="1rem" rounded="15px" m={{ b: "1rem" }}>
				<Text textSize="caption" textColor={theme.colors.text_light}>
					codice per entrare in {schoolName}
				</Text>
				<Text textSize="title" textWeight="bold" m={{ b: "0.5rem" }}>
					{invite.code}
				</Text>
				{/* con che ruolo si entra, e se si insegna: quello che si è scelto */}
				<Text textSize="caption" textColor={theme.colors.text_light}>
					{ROLE_LABELS[role]}
					{invite.teaches === false ? " · non insegna" : ""}
					{" · "}
					vale fino al {expires.toFormat("d LLLL")}
				</Text>
			</Div>

			<Div
				d="flex"
				align="center"
				justify="center"
				cursor="pointer"
				m={{ b: "1rem" }}
				style={{ gap: "0.5rem" }}
				onClick={copy}>
				<FontAwesomeIcon icon={faCopy} color={theme.colors.primary} />
				<Text textSize="body" textColor={theme.colors.primary}>
					Copia il messaggio da mandargli
				</Text>
			</Div>
		</>
	)
}

export default InviteCredentials
